import { ContainerFluid, Section } from '@/atoms';
import { Blok } from '@/bloks/Blok';
import { LinkButton, LinkButtonProps } from '@/bloks/Button';
import { UpsalesForm } from '@/bloks/Form';
import { HeaderCommon } from '@/bloks/Other';
import { HeaderFormStoryblok, RichtextStoryblok, UpsalesFormStoryblok } from '@/components';
import { ImpressionTrackingProvider } from '@/contexts/piwik/ImpressionTrackingProvider';
import { ISbStoryData } from '@/types/storyblok';
import { editableBlok } from '@/utils/storyblok';
import cls from 'classnames';
import styles from './HeaderForm.module.scss';

interface BlokProps {
	blok: HeaderFormStoryblok;
	meta?: {
		zone?: number;
	};
}

const blokProps = ({ blok, meta }: BlokProps): Props => ({
	title: blok.title,
	text: blok.text,
	linkButtons: blok.linkButtons?.map((blok) => LinkButton.blokProps({ blok })),
	form: blok.form && typeof blok.form !== 'string' ? (blok.form as ISbStoryData<UpsalesFormStoryblok>) : undefined,
	zone: meta?.zone,
	_editable: blok._editable,
});

interface Props {
	title: string;
	text?: RichtextStoryblok;
	linkButtons?: LinkButtonProps[];
	form?: ISbStoryData<UpsalesFormStoryblok>;
	zone?: number;
	_editable?: string;
}

export const HeaderForm: Blok<Props, BlokProps> = ({ title, text, linkButtons, form, zone, _editable }) => {
	return (
		<ImpressionTrackingProvider
			value={{ contentName: `${zone}|HeaderForm`, contentPiece: title, contentTarget: 'Skicka' }}
		>
			<ContainerFluid contrast="darkText">
				<Section {...editableBlok({ _editable })}>
					<div className={cls(styles.container)}>
						{title && (
							<HeaderCommon
								titlePart1={title}
								text={text}
								linkButtons={linkButtons}
								layout="center"
								titleSize="h1"
								marginBottom="3xl"
							/>
						)}

						{form && (
							<UpsalesForm
								{...UpsalesForm.blokProps({
									story: form,
									meta: { layout: 'twoCols' },
								})}
							/>
						)}
					</div>
				</Section>
			</ContainerFluid>
		</ImpressionTrackingProvider>
	);
};

HeaderForm.blokProps = blokProps;
